class GeneralLogRecord {
	constructor(description, amount) {
		this.description = description;
		this.amount = amount;
	}

	toPlainObj() {
		return {
			description: this.description,
			amount: this.amount
		};
	}
};

export default function GeneralLogRecordBuilder() {
	return {
		withDescription: function (description) {
			this.description = description;
			return this;
		},
		withAmount: function (amount) {
			this.amount = amount;
			return this;
		},
		build: function () {
			return new GeneralLogRecord(this.description, this.amount);
		}
	};
}
